import React, { Component } from 'react';
import Modal from 'react-modal';
import './Modal.css'
import Close from '@material-ui/icons/Close'



class LocalModal extends Component {

    state = {
        modalIsOpen: false,
        setIsOpen: false
    }
    openModal = () => {
        this.setState({ setIsOpen: true });
        this.setState({ modalIsOpen: true });
    }
    closeModal = () => {
        if (this.props.closePermission === false) {
            return
        } else {
            this.setState({ setIsOpen: false });
            this.setState({ modalIsOpen: false });
            this.props.closeModal()
        }
    }
    render() {
        function afterOpenModal() {
        }

        const customStyles = {
            overlay: {
                zIndex: '10000'
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                // marginTop: '50px',
                width: this.props.with,
                minWidth: '300px',
                overflow: 'auto',
                maxHeight: '100vh',
                direction: 'ltr',
                zIndex: '999',
                position: 'fixed'
            }
        };
        return (
            <div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.state.afterOpenModal}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className='modal-close' onClick={this.closeModal}><Close className="ModalIcon" /></div>
                    <div dir="rtl">
                        {this.props.content}
                    </div>
                </Modal>
            </div >
        );
    }
}
export default LocalModal